export default __webpack_public_path__ + "static/media/6FDF0CF7-B6B9-43C6-AEBC-0F9591FFB1CD_1_105_c.5bbf3feb.jpeg";